module.exports = __webpack_public_path__ + "static/media/linkedin.154629f2.svg";